import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
   flexGrow: 1,
 },
 title: {
   flexGrow: 1,
 },
 appBar: {
   alignItems: 'center'
 }
}));

export default useStyles;
